import React, { Component } from 'react'
import { observer } from 'mobx-react'

import Modal from '../../../../UniformComponents/Modal'

@observer
export default class EditAnswersModal extends Component {
    componentDidMount() {
        window.addEventListener('message', this.onMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.onMessage)
    }

    onMessage = (e) => {
        const { reportStore } = this.props
        const { editAnswersModalIsOpen } = reportStore
        if (e.data === 'closeEditAnswersModal' && editAnswersModalIsOpen) this.hide()
    }

    hide = () => {
        const { toggleEditAnswers } = this.props
        toggleEditAnswers()
    }

    render() {
        const { reportStore } = this.props
        const { editAnswersModalIsOpen, editAnswersURL } = reportStore

        return (
            <Modal
                show={editAnswersModalIsOpen}
                onClose={this.hide}
                size="x-large"
                style={{ height: '75vh' }}
            >
                <div
                    style={{ height: '65vh' }}
                >
                    <iframe
                        title="Maxbi"
                        style={{ width: '100%', height: '100%', border: 0 }}
                        src={editAnswersURL}
                    />
                </div>
            </Modal>
        )
    }
}
